import React from "react";
import "./TextField.scss";

function TextField({
  placeholder,
  value,
  onChange,
  disabled,
  label,
  invalid,
  errorMessage = "This field is required",
}) {
  return (
    <div className="form-field">
      {placeholder && <div className="dropdown-placeholder">{placeholder}</div>}
      <input
        type="text"
        className={`textField ${invalid ? "textField-invalid" : ""}`}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {invalid && <div className="form-error-message">{errorMessage}</div>}
    </div>
  );
}

export default TextField;

// import React from "react";
// import "./TextField.scss";

// function TextField({ placeholder, value, onChange, disabled }) {
//   return (
//     <>
//       <div className="dropdown-label">{placeholder}</div>
//       <input
//         type="text"
//         className="textField"
//         placeholder={placeholder}
//         disabled={disabled}
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//       />
//     </>
//   );
// }

// export default TextField;
